import React from 'react';
import { Link } from 'react-router-dom';
import type { HomepageHeatResponse } from '../../../apiClient';

interface RecentReceiptsRailProps {
  heat: HomepageHeatResponse;
}

const RecentReceiptsRail: React.FC<RecentReceiptsRailProps> = ({ heat }) => {
  const items = heat.items.slice(0, 3);
  if (items.length === 0) return null;

  return (
    <section className="max-w-6xl mx-auto mb-14">
      <div className="flex items-end justify-between gap-4 mb-5">
        <div>
          <p className="text-[10px] font-black uppercase tracking-[0.28em] text-gold-600 dark:text-gold-400 mb-2">Recent receipts</p>
          <h2 className="text-2xl sm:text-3xl font-black uppercase tracking-tight text-navy-900 dark:text-cream-50">Fresh proof worth opening right now.</h2>
        </div>
        <Link to="/officials?sort=recent" className="hidden sm:inline-flex text-[10px] font-black uppercase tracking-widest text-navy-500 hover:text-gold-600 dark:text-cream-300 dark:hover:text-gold-400 transition">
          Browse all recent movement
        </Link>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        {items.map((item) => (
          <article key={`${item.officialId}-${item.eventTimestamp}`} className="rounded-2xl border border-cream-300 dark:border-navy-600 bg-white dark:bg-navy-800/40 p-5">
            <div className="flex items-center justify-between gap-3">
              <span className="rounded-full border border-gold-500/30 bg-gold-500/10 px-2.5 py-1 text-[9px] font-black uppercase tracking-widest text-gold-600 dark:text-gold-400">{item.eventLabel}</span>
              <span className="text-[10px] font-bold uppercase tracking-widest text-navy-400 dark:text-navy-300">{new Date(item.eventTimestamp).toLocaleDateString()}</span>
            </div>
            <h3 className="mt-4 text-lg font-black uppercase tracking-tight text-navy-900 dark:text-cream-50">{item.headline}</h3>
            <p className="mt-2 text-sm text-navy-500 dark:text-cream-300 leading-relaxed">{item.detail}</p>
            <div className="mt-5 flex flex-wrap gap-3 text-[10px] font-black uppercase tracking-widest">
              <Link to={`/officials/${item.officialId}`} className="text-navy-700 hover:text-gold-600 dark:text-cream-200 dark:hover:text-gold-400 transition">Open dossier</Link>
              <Link to={item.sourcePath} className="text-navy-400 hover:text-gold-600 dark:text-navy-300 dark:hover:text-gold-400 transition">{item.sourceLabel}</Link>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default RecentReceiptsRail;
